/* CRIS DUPLICATE · Desktop only.
   Mantiene abierto Ropa > Categorías mientras el mega-menu siga abierto,
   para poder mover el ratón a la segunda columna y hacer clic. */
(function () {
  'use strict';

  function isDesktop() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  function init() {
    var panel = document.querySelector('[data-moray-mega]');
    if (!panel) return;

    document.addEventListener('mouseover', function (event) {
      if (!isDesktop()) return;
      var group = event.target.closest('[data-cris-categories]');
      if (group) group.open = true;
    });

    document.addEventListener('mouseout', function (event) {
      if (!isDesktop()) return;
      var group = event.target.closest('[data-cris-categories]');
      if (!group) return;

      /* El script base intenta cerrarlo al abandonar el summary. Lo reabrimos
         al final del frame mientras siga abierto el mega-menu completo. */
      window.requestAnimationFrame(function () {
        if (panel.classList.contains('is-open')) group.open = true;
      });
    });

    /* Al cerrar Ropa sí devolvemos Categorías a su estado cerrado. */
    var observer = new MutationObserver(function () {
      if (panel.classList.contains('is-open')) return;
      panel.querySelectorAll('[data-cris-categories][open]').forEach(function (group) {
        group.open = false;
      });
    });

    observer.observe(panel, {
      attributes: true,
      attributeFilter: ['class', 'hidden']
    });
  }

  /* Registramos después de los scripts defer del header para que este parche
     se ejecute después del comportamiento base. */
  window.addEventListener('load', init, { once: true });
})();
